'use client'

import { useTranslations } from 'next-intl'
import { Button } from '@/components/ui/button'

export default function ErrorPage({ reset }: { reset: () => void }) {
  const t = useTranslations('error')
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-6 p-8 text-center">
      <h1 className="text-3xl font-bold">{t('title')}</h1>
      <p>{t('description')}</p>
      <Button onClick={reset}>{t('tryAgain')}</Button>
    </main>
  )
}
